/* Mobile content entrances keep their normal tempo until native scrolling
   asks them to catch up. No scroll position or page geometry is changed. */
(() => {
  if (window.AKMobileMotion) return;
  const mobile = matchMedia('(max-width:1200px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const main = document.getElementById('MainContent');
  if (!main) return;
  const inner = document.body.classList.contains('ak-page-inner');
  const owner = inner ? main : (document.scrollingElement || document.documentElement);
  const scrollTop = () => inner ? main.scrollTop : Math.max(owner.scrollTop, document.body.scrollTop, document.documentElement.scrollTop);
  const excluded = '.ak-posters-mobile-purchase-panel,.ak-mobile-purchase-row,.ak-ath-product__purchase,.ak-kingpong-options,[data-ak-price-request-panel],[role="dialog"],.ak-mobile-directory,.ak-search-overlay,.ak-cart-drawer,.ak-film-simple-section';
  const boundaries = 'section.ak-featured-carousel,.ak-vpcompress22-mobile,.ak-theend-v2,.ak-session-one-heading,.ak-simple-session-one-media,.ak-session-2,.ak-session-3,.ak-session-6,[data-ak-collection-mobile-list],[data-ak-astro],.ak-about__sticky-stage,.shopify-section';
  const tasks = new Set();
  const managed = new Map();
  const stats = {boosted:0, completed:0, timers:0, fastScrolls:0};
  let frame = 0, scanAt = 0, activeUntil = 0, intentAt = -Infinity;
  let previousTop = scrollTop(), previousAt = performance.now();
  let fastAt = -Infinity, speed = 0, moved = false;

  function enabled() {
    return mobile.matches && !reduced.matches && !document.hidden &&
      !(window.AK_NATIVE_ZOOM?.isZooming()) &&
      !(window.visualViewport && Math.abs(window.visualViewport.scale - 1) > .01) &&
      !document.documentElement.matches('.ak-mobile-directory-active,.ak-search-overlay-open') &&
      !document.body.classList.contains('ak-mobile-cart-is-open');
  }
  function rate(now = performance.now()) {
    if (!enabled() || now - fastAt > 650) return 1;
    return Math.min(6, Math.max(1, 1 + (speed - .7) * 1.6));
  }
  function passed(element) {
    if (!mobile.matches || !moved || !element?.isConnected) return false;
    const rect = element.getBoundingClientRect();
    const top = document.querySelector('.ak-site-frame-rail--left')?.getBoundingClientRect().top || 45;
    return rect.width > 0 && rect.height > 0 && rect.bottom <= top;
  }
  function queue() {
    if (!frame && !document.hidden) frame = requestAnimationFrame(tick);
  }
  function scan(now) {
    if (!enabled()) return;
    const pastBoundaries = new Map();
    for (const animation of document.getAnimations()) {
      const target = animation.effect?.target;
      if (!(target instanceof Element) || !main.contains(target) || target.closest(excluded) ||
          target.matches('button,input,select,textarea,.splide__list') ||
          animation.playState !== 'running') continue;
      const timing = animation.effect.getComputedTiming();
      if (!Number.isFinite(timing.endTime) || timing.endTime <= 0 ||
          animation.effect.getTiming().iterations === Infinity) continue;
      const boundary = target.closest(boundaries) || target;
      if (!pastBoundaries.has(boundary)) pastBoundaries.set(boundary, passed(boundary));
      if (pastBoundaries.get(boundary)) {
        try { animation.finish(); stats.completed++; } catch (_) {}
        continue;
      }
      const multiplier = rate(now);
      if (multiplier <= 1) continue;
      let record = managed.get(animation);
      if (!record) {
        record = {base:animation.playbackRate || 1, multiplier:1};
        managed.set(animation, record);
      }
      // Keep the earned speed through completion; never slow an entrance
      // halfway through simply because the finger has left the screen.
      if (multiplier > record.multiplier + .1) {
        const next = record.base * multiplier;
        if (animation.updatePlaybackRate) animation.updatePlaybackRate(next);
        else animation.playbackRate = next;
        record.multiplier = multiplier;
        stats.boosted++;
      }
    }
    for (const [animation] of managed) {
      if (animation.playState === 'finished' || animation.playState === 'idle') managed.delete(animation);
    }
  }
  function tick(now) {
    frame = 0;
    if (document.hidden) return;
    for (const task of [...tasks]) {
      const elapsed = Math.max(0, now - task.at);
      task.at = now;
      task.rate = Math.max(task.rate, rate(now));
      task.remaining -= elapsed * task.rate;
      if (passed(task.owner) || task.remaining <= 0) {
        tasks.delete(task);
        task.callback();
      }
    }
    if (now >= scanAt && (now < activeUntil || tasks.size)) {
      scanAt = now + (rate(now) > 1 ? 50 : 120);
      scan(now);
    }
    if (tasks.size || now < activeUntil) queue();
  }
  function scroll(event) {
    if (inner ? event.target !== main : ![document, owner, document.body, document.documentElement].includes(event.target)) return;
    const now = performance.now(), top = scrollTop();
    const distance = Math.abs(top - previousTop);
    const elapsed = Math.min(160, Math.max(16, now - previousAt));
    previousTop = top; previousAt = now;
    if (!enabled() || now - intentAt > 2500 || distance < 1) return;
    moved = true;
    const viewport = window.innerHeight || 800;
    const priorRate = rate(now);
    const measured = distance / elapsed * 1000 / viewport;
    speed = Math.max(measured, now - fastAt < 180 ? speed * .8 : 0);
    if (distance >= viewport * .45) speed = Math.max(speed, 4);
    fastAt = now;
    if (rate(now) > 1.2) {
      if (priorRate <= 1.2) scanAt = 0;
      stats.fastScrolls++;
    }
    activeUntil = now + 750;
    queue();
  }
  function reset() {
    previousTop = scrollTop(); previousAt = performance.now();
    speed = 0; fastAt = -Infinity; intentAt = -Infinity; moved = false;
    if (!mobile.matches) {
      for (const [animation, record] of managed) {
        if (animation.playState === 'running') {
          if (animation.updatePlaybackRate) animation.updatePlaybackRate(record.base);
          else animation.playbackRate = record.base;
        }
      }
      managed.clear();
    }
  }
  window.AKMobileMotion = {
    rate, passed,
    after(callback, milliseconds, element) {
      if (!mobile.matches || reduced.matches) {
        const timer = setTimeout(callback, milliseconds);
        return {cancel:() => clearTimeout(timer)};
      }
      const task = {callback, owner:element, remaining:milliseconds, at:performance.now(), rate:rate()};
      tasks.add(task); stats.timers++; queue();
      return {cancel:() => tasks.delete(task)};
    },
    snapshot:() => ({...stats, rate:rate(), mobile:mobile.matches, pending:tasks.size})
  };
  ['touchstart','pointerdown','wheel','keydown'].forEach(name => document.addEventListener(name, event => {
    if (event.isTrusted) intentAt = performance.now();
  }, {capture:true, passive:true}));
  document.addEventListener('scroll', scroll, {capture:true, passive:true});
  ['animationstart','transitionrun'].forEach(name => main.addEventListener(name, () => {
    if (rate() > 1) { activeUntil = performance.now() + 750; queue(); }
  }, true));
  window.addEventListener('pageshow', reset);
  window.addEventListener('ak:browser-resume',()=>{cancelAnimationFrame(frame);frame=0;reset();const now=performance.now();tasks.forEach(task=>{task.at=now;});if(tasks.size)queue();});
  mobile.addEventListener('change', reset);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {cancelAnimationFrame(frame);frame=0;}
    else {
      const now = performance.now(); tasks.forEach(task => {task.at = now;});
      reset(); if (tasks.size) queue();
    }
  });
})();
